import { gql } from '@apollo/client';

export const GET_BOOK_CREDIT_LIST = gql`
  query getBookCreditList($campus_idx: Int!) {
    getBookCreditList(campus_idx: $campus_idx) {
      book_code
      view_book_code
      credit_type
      cnt
      days
      unused_cnt
    }
  }
`;

export const GET_CAMPUS_BOOK_CREDIT_LIST = gql`
  query getCampusBookCreditList($campus_idx: Int!, $code: String!) {
    getCampusBookCreditList(campus_idx: $campus_idx, code: $code) {
      book_code
      cnt
    }
  }
`;

export const GET_CAMPUS_BOOK_CREDIT_COUNT = gql`
  query getCampusBookCreditCount($campus_idx: Int!, $book_code: String!, $days: Int, $filter_days: Boolean) {
    getCampusBookCreditCount(campus_idx: $campus_idx, book_code: $book_code, days: $days, filter_days: $filter_days)
  }
`;

export const GET_CAMPUS_MULTI_BOOK_CREDIT_COUNT = gql`
  query getCampusMultiBookCreditCount($campus_idx: Int!, $book_codes: [String!]!) {
    getCampusMultiBookCreditCount(campus_idx: $campus_idx, book_codes: $book_codes) {
      book_code
      cnt
    }
  }
`;

export const GET_BOOK_COMPANY_CREDIT_LIST = gql`
  query getCompanyBookCreditByMonth($company_idx: Int!, $month: String!) {
    getCompanyBookCreditByMonth(company_idx: $company_idx, month: $month) {
      idx
      cnt
      campus {
        idx
        name
      }
      prev_cnt(month: $month)
      manual_cnt(month: $month)
    }
  }
`;

export const GET_CAMPUS_BOOK_CREDIT_DETAIL_LIST = gql`
  query getCampusBookCreditDetailList($campus_idx: Int!, $month: String!) {
    getCampusBookCreditDetailList(campus_idx: $campus_idx, month: $month) {
      book {
        code
        book_sub {
          title
        }
      }
      view_book_code
      view_book_days_title
      day
      credit_type
      cnt
    }
  }
`;

export const GET_CAMPUS_STUDENT_ASSIGNED_TICKET_LIST = gql`
  query getCampusStudentAssignedTicketList($campus_idx: Int!, $q: String, $expire_within_days: Int) {
    getCampusStudentAssignedTicketList(campus_idx: $campus_idx, q: $q, expire_within_days: $expire_within_days) {
      idx
      book_code
      user {
        name
        id
        stat
        class_student {
          class_idx
        }
      }
      book_credit {
        idx
        credit_type
        study_type
        issue_datetime
        idate
      }
      book_start_datetime
      book_end_datetime
      lesson_complete
    }
  }
`;

export const GET_CAMPUS_CREDIT_USED_STATUS_LIST = gql`
  query getCampusBookCreditUsedStatusList($campus_idx: Int!) {
    getCampusBookCreditUsedStatusList(campus_idx: $campus_idx) {
      book_code
      total
      unused
    }
  }
`;

export const CAMPUS_BOOK_CREDIT_INFO_LIST = gql`
  query getCampusBookCreditInfoList($campus_idx: Int!) {
    getCampusBookCreditInfoList(campus_idx: $campus_idx) {
      idx
      book_code
      credit_count
      used_count
      latest_date
      latest_book_credit_count
      days
      book {
        book_sub {
          title
          book_category {
            name
          }
        }
      }
    }
  }
`;

export const CAMPUS_STUDENT_BOOK_CREDIT_ASSIGNED_LIST_GROUP_BY_CLASS = gql`
  query getCampusStudentBookCreditAssignedListGroupByClass($campus_idx: Int!, $ym: String!) {
    getCampusStudentBookCreditAssignedListGroupByClass(campus_idx: $campus_idx, ym: $ym) {
      idx
      class_idx
      regdate
      credit_count
      book_code
      book_start_datetime
      book_end_datetime
      start_datetime
      end_datetime
      class_name
      days
      book {
        book_sub {
          title
          book_category {
            name
          }
        }
      }
      class {
        name
      }
    }
  }
`;
export const ENGLISHTAP_BOOK_CREDIT_CHECK = gql`
  query hasValidRootBookCredit($user_idx: Int!, $company_idx: Int!, $root_book_code: String!) {
    hasValidRootBookCredit(user_idx: $user_idx, company_idx: $company_idx, root_book_code: $root_book_code)
  }
`;

export const ENGLISHTAP_BOOK_CREDIT_CHECK_MULTI = gql`
  query hasValidRootBookCreditMultiple($user_idx: Int!, $company_idx: Int!, $root_book_codes: [String!]!) {
    hasValidRootBookCreditMultiple(user_idx: $user_idx, company_idx: $company_idx, root_book_codes: $root_book_codes)
  }
`;

export const GET_COMPANY_HEADQUARTERS_BOOK_CREDIT_STATISTICS = gql`
  query getCompanyHeadquartersBookCreditStatistics($company_idx: Int, $from_date: String, $to_date: String, $period_days: Int) {
    getCompanyHeadquartersBookCreditStatistics(
      company_idx: $company_idx
      from_date: $from_date
      to_date: $to_date
      period_days: $period_days
    ) {
      period_from
      period_to
      product_stats {
        product_key
        product_name
        charged_total_quantity
        used_total_quantity
        used_total_settlement_amount
      }
      academy_stats {
        academy_idx
        academy_name
        product_key
        product_name
        charged_total_quantity
        used_total_quantity
        used_total_settlement_amount
      }
      academy_usage_details {
        detail_type
        academy_idx
        academy_name
        product_name
        class_name
        textbook_info
        student_name
        student_id
        learning_start_date
        learning_end_date
        application_date
        test_completion_date
        test_type
      }
    }
  }
`;
